// extracted by mini-css-extract-plugin
export default {"title":"Description_title__tzjRJ","content":"Description_content__pSZig"};